import styled from "styled-components"
import { BaseButton } from "../button/button.styles"

export const FormWrapper = styled.div`
  width: 50%;

  @media screen and (max-width: 1000px) {
    width: 100%;
  }
`

export const FormContainer = styled.form`
  width: 100%;

  h2 {
    font-weight: 500;
    color: #f2f2f2;
    font-size: 1.5rem;
    margin-block-start: 0rem;
    margin-block-end: 0rem;

    @media screen and (max-width: 1000px) {
      font-size: 1.35rem;
      text-align: center;
    }
  }

  /* .change{
    height:2.625rem ;
    width: 100%;
    margin:1rem 0 ;
  } */
`

export const PersonalInformation = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 2.5rem;

  @media screen and (max-width: 1000px) {
    flex-direction: column;
    gap: 0;
  }

  .jumi {
    width: 50%;

    @media screen and (max-width: 1000px) {
      width: 100%;
    }
  }
`

export const FormInput = styled.input`
  padding: 1rem 0.625rem 1rem 1rem;
  background: rgba(36, 61, 72, 0.95);
  border-radius: 6px;
  color: white;
  outline: none;
  width: 100%;
  font-family: "Rubik", sans-serif;
  font-size: 1rem;
  box-sizing: border-box;
  transition: all 0.3s ease;
  border: 1px solid rgba(255, 255, 255, 0.16);
  box-shadow:
    inset 0 0 0 1px rgba(255, 255, 255, 0.04),
    0 0.5rem 1.2rem rgba(0, 0, 0, 0.18);

  &::placeholder {
    color: rgba(255, 255, 255, 0.48);
  }

  &:hover {
    background: rgba(42, 72, 84, 0.98);
    border-color: rgba(255, 255, 255, 0.28);
  }

  &:focus {
    color: white;
    background: rgba(44, 78, 92, 1);
    border: 1px solid #f08a4b;
    box-shadow:
      0 0 0 3px rgba(240, 138, 75, 0.18),
      0 0.5rem 1.2rem rgba(0, 0, 0, 0.22);
  }
`

export const InputSection = styled.div`
  margin-top: 1rem;

  label {
    color: #f2f2f2;
    font-size: 1rem;
    font-weight: 400;
    display: block;
    margin-bottom: 0.75rem;
  }

  #problem {
    height: 9.5rem;
  }

  .phoneInput {
    position: relative;

    .error {
      font-size: 0.8rem;
      position: absolute;
      bottom: -1.2rem;
      color: #d63535;
    }
  }
`

export const SuccessSubmit = styled.div`
  transition: all 0.3s ease;
  margin: 1rem 0;
  background: #2fa62d;
  border-radius: 0.75rem;
  width: 100%;
  font-size: 0.875rem;
  padding: 0.75rem;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  justify-content: space-between;

  div {
    display: flex;
    align-items: center;

    img {
      width: 1rem;
      margin-right: 0.625rem;
      cursor: default;
    }
  }

  img {
    width: 1rem;
    cursor: pointer;
  }
`

export const TextArea = styled.textarea`
  resize: none;
  height: 9rem;
  padding: 1rem 1.625rem 1rem 1rem;
  background: rgba(36, 61, 72, 0.95);
  border-radius: 6px;
  color: white;
  outline: none;
  width: 100%;
  font-family: "Rubik", sans-serif;
  font-size: 1rem;
  box-sizing: border-box;
  transition: all 0.3s ease;
  border: 1px solid rgba(255, 255, 255, 0.16);
  box-shadow:
    inset 0 0 0 1px rgba(255, 255, 255, 0.04),
    0 0.5rem 1.2rem rgba(0, 0, 0, 0.18);

  &::placeholder {
    color: rgba(255, 255, 255, 0.48);
  }

  &:hover {
    background: rgba(42, 72, 84, 0.98);
    border-color: rgba(255, 255, 255, 0.28);
  }

  &:focus {
    color: white;
    background: rgba(44, 78, 92, 1);
    border: 1px solid #f08a4b;
    box-shadow:
      0 0 0 3px rgba(240, 138, 75, 0.18),
      0 0.5rem 1.2rem rgba(0, 0, 0, 0.22);
  }
`

export const FormButton = styled(BaseButton)`
  margin: 0 0 0 auto;
  padding: 0.9rem 1.5rem 1rem;

  font-size: 1rem;
  color: #ffffff;
  font-weight: 500;
  width: auto;
  height: auto;
  border: none;
  outline: none;
  cursor: pointer;
  border-radius: 0.75rem;
  transition: all 0.3s ease;
  background: linear-gradient(96.18deg, #f08a4b 1.56%, #d9a526 86.86%);
  box-shadow: 0px 0.5625rem 0.875rem rgba(240, 138, 75, 0.25);

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0px 0.75rem 1.2rem rgba(240, 138, 75, 0.32);
  }

  &:active {
    transform: translateY(0);
  }

  @media screen and (max-width: 1000px) {
    width: 100%;
  }
`

export const SubmitButton = styled.div`
  width: 100%;
  margin-top: 1rem;
  display: flex;
  justify-content: flex-end;
`